// 配置首页路由；留空或无权限时默认回到 "/"
export const HOME_PATH = '/portal/dsp/siteManagement/workBench'
